import { connect } from 'react-redux';
import CheckinModal from '../components/blocks/checkin/CheckinModal';
import { isUserClient } from '../helpers';
import { closeModal, openModal } from '../redux/actions/modal';
import { checkIn } from '../redux/actions/work-sessions';
import { CHECKIN_MODAL } from '../redux/reducers/modal';
import type { SingleModalState, State } from '../types';

const mapStateToProps = (state: State) => ({
  loading: state.workSessions.loading,
  error: state.workSessions.error,
  needsRemoteCheckin: state.currentUser.needsRemoteCheckin,
  isUserClient: isUserClient(state.currentUser),
  modal: state.modal[CHECKIN_MODAL] || { display: false, id: CHECKIN_MODAL, disableButtons: false },
  modalId: CHECKIN_MODAL,
});

const mapDispatchToProps = (dispatch: any) => ({
  onCheckIn: (sessionType: 'remote' | 'remote_sick' | 'sick' | 'business_trip') => {
    dispatch(checkIn(sessionType));
  },
  onCloseModal: (modal: SingleModalState) => {
    dispatch(closeModal(modal));
  },
  onOpenModal: (modal: SingleModalState) => {
    dispatch(openModal(modal));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckinModal);
